/**
 * @generated SignedSource<<c49f80c52789fe0d59607065583130c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateCustomMcpServerInput = {
  authType?: string | null | undefined;
  credentials?: string | null | undefined;
  description?: string | null | undefined;
  id: any;
  name?: string | null | undefined;
  url?: string | null | undefined;
};
export type McpServersOnboardingContentUpdateMutation$variables = {
  input: UpdateCustomMcpServerInput;
};
export type McpServersOnboardingContentUpdateMutation$data = {
  readonly updateCustomMcpServer: {
    readonly error: string | null | undefined;
    readonly server: {
      readonly id: any;
      readonly name: string;
    } | null | undefined;
  };
};
export type McpServersOnboardingContentUpdateMutation = {
  response: McpServersOnboardingContentUpdateMutation$data;
  variables: McpServersOnboardingContentUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CustomMcpServerPayload",
    "kind": "LinkedField",
    "name": "updateCustomMcpServer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLCustomMcpServer",
        "kind": "LinkedField",
        "name": "server",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "McpServersOnboardingContentUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "McpServersOnboardingContentUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "eef4d60f325b029476e580cc26eb38f3",
    "id": null,
    "metadata": {},
    "name": "McpServersOnboardingContentUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation McpServersOnboardingContentUpdateMutation(\n  $input: UpdateCustomMcpServerInput!\n) {\n  updateCustomMcpServer(input: $input) {\n    server {\n      id\n      name\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "34bb5413d0dd94bbe6bdac49979a04a5";

export default node;
